import React from 'react';
import PropTypes from 'prop-types';

function NoSearchResults(props) {
  const { height, width } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="16.8801"
        y="32.2366"
        width="16.12"
        height="4.68"
        rx="0.26"
        fill="#F1F1F1"
        stroke="#A3A3A3"
        strokeWidth="0.52"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2197 35.6191C19.7941 35.6191 20.2597 35.1534 20.2597 34.5791C20.2597 34.0047 19.7941 33.5391 19.2197 33.5391C18.6453 33.5391 18.1797 34.0047 18.1797 34.5791C18.1797 35.1534 18.6453 35.6191 19.2197 35.6191Z"
        fill="#A3A3A3"
      />
      <rect x="22.8604" y="34.0547" width="6.5" height="1.04" rx="0.52" fill="#A3A3A3" />
      <rect
        x="16.8801"
        y="23.9162"
        width="16.12"
        height="4.68"
        rx="0.26"
        fill="#F1F1F1"
        stroke="#A3A3A3"
        strokeWidth="0.52"
      />
      <rect
        x="16.8801"
        y="15.5959"
        width="16.12"
        height="4.68"
        rx="0.26"
        fill="#F1F1F1"
        stroke="#A3A3A3"
        strokeWidth="0.52"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2207 27.2987C19.795 27.2987 20.2607 26.8331 20.2607 26.2587C20.2607 25.6844 19.795 25.2188 19.2207 25.2188C18.6463 25.2188 18.1807 25.6844 18.1807 26.2587C18.1807 26.8331 18.6463 27.2987 19.2207 27.2987Z"
        fill="#A3A3A3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2207 18.9784C19.795 18.9784 20.2607 18.5128 20.2607 17.9384C20.2607 17.3641 19.795 16.8984 19.2207 16.8984C18.6463 16.8984 18.1807 17.3641 18.1807 17.9384C18.1807 18.5128 18.6463 18.9784 19.2207 18.9784Z"
        fill="#A3A3A3"
      />
      <rect x="22.8604" y="25.7344" width="6.5" height="1.04" rx="0.52" fill="#A3A3A3" />
      <rect x="22.8604" y="17.4141" width="6.5" height="1.04" rx="0.52" fill="#A3A3A3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.6386 43.1116L37.9985 36.4714C39.0314 35.2171 39.6954 33.594 39.6954 31.8233C39.6954 27.7654 36.3753 24.4453 32.3174 24.4453C28.2595 24.4453 24.9395 27.7654 24.9395 31.8233C24.9395 35.8812 28.2595 39.2012 32.3174 39.2012C34.0881 39.2012 35.7113 38.611 36.9655 37.5043L43.6057 44.1445C43.7533 44.292 43.9746 44.3658 44.1222 44.3658C44.2697 44.3658 44.4911 44.292 44.6386 44.1445C44.9337 43.8494 44.9337 43.4067 44.6386 43.1116Z"
        fill="#53B7B0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.21 37.6915C28.9637 37.6915 26.3076 35.0354 26.3076 31.7891C26.3076 28.5428 28.9637 25.8867 32.21 25.8867C35.4563 25.8867 38.1124 28.5428 38.1124 31.7891C38.1124 35.0354 35.4563 37.6915 32.21 37.6915Z"
        fill="white"
      />
      <mask
        id="mask0_1768_51911"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="26"
        y="25"
        width="13"
        height="13"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.21 37.6915C28.9637 37.6915 26.3076 35.0354 26.3076 31.7891C26.3076 28.5428 28.9637 25.8867 32.21 25.8867C35.4563 25.8867 38.1124 28.5428 38.1124 31.7891C38.1124 35.0354 35.4563 37.6915 32.21 37.6915Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1768_51911)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.5564 32.797V32.5535C31.5564 32.2745 31.6072 32.0424 31.7086 31.8572C31.8101 31.672 31.9876 31.4805 32.2413 31.2827C32.5432 31.0442 32.7378 30.8591 32.8254 30.7272C32.9129 30.5953 32.9566 30.438 32.9566 30.2554C32.9566 30.0423 32.8856 29.8787 32.7436 29.7645C32.6015 29.6504 32.3973 29.5933 32.131 29.5933C31.89 29.5933 31.6668 29.6276 31.4613 29.696C31.2558 29.7645 31.0555 29.847 30.8601 29.9434L30.5405 29.2737C31.0555 28.9871 31.6072 28.8438 32.1956 28.8438C32.6928 28.8438 33.0873 28.9655 33.379 29.209C33.6707 29.4525 33.8165 29.7886 33.8165 30.2173C33.8165 30.4076 33.7886 30.5769 33.7328 30.7253C33.677 30.8737 33.5927 31.0151 33.4798 31.1495C33.3669 31.2839 33.1722 31.459 32.8957 31.6746C32.6598 31.8598 32.5019 32.0132 32.422 32.135C32.3421 32.2567 32.3022 32.4203 32.3022 32.6258V32.797H31.5564ZM31.4004 34.353C31.4004 33.97 31.5868 33.7785 31.9597 33.7785C32.1423 33.7785 32.2819 33.8286 32.3782 33.9288C32.4746 34.029 32.5228 34.1704 32.5228 34.353C32.5228 34.5331 32.474 34.6758 32.3763 34.7811C32.2787 34.8863 32.1398 34.939 31.9597 34.939C31.7796 34.939 31.6414 34.8876 31.545 34.7849C31.4486 34.6822 31.4004 34.5382 31.4004 34.353Z"
        fill="#53B7B0"
      />
      <path
        d="M31.5564 32.797H31.4264V32.927H31.5564V32.797ZM32.2413 31.2827L32.3213 31.3852L32.3219 31.3847L32.2413 31.2827ZM30.8601 29.9434L30.7428 29.9994L30.7995 30.1182L30.9177 30.0599L30.8601 29.9434ZM30.5405 29.2737L30.4773 29.1601L30.3706 29.2195L30.4232 29.3297L30.5405 29.2737ZM32.8957 31.6746L32.8158 31.5721L32.8155 31.5723L32.8957 31.6746ZM32.3022 32.797V32.927H32.4322V32.797H32.3022ZM31.6864 32.797V32.5535H31.4264V32.797H31.6864ZM31.6864 32.5535C31.6864 32.2895 31.7345 32.0805 31.8226 31.9197L31.5946 31.7947C31.4798 32.0042 31.4264 32.2594 31.4264 32.5535H31.6864ZM31.8226 31.9197C31.9123 31.756 32.075 31.5773 32.3213 31.3852L32.1614 31.1802C31.9003 31.3838 31.7079 31.5881 31.5946 31.7947L31.8226 31.9197ZM32.3219 31.3847C32.6235 31.1465 32.8335 30.9501 32.9337 30.799L32.717 30.6553C32.6422 30.7681 32.4628 30.942 32.1607 31.1807L32.3219 31.3847ZM32.9337 30.799C33.0374 30.6427 33.0866 30.4595 33.0866 30.2554H32.8266C32.8266 30.4165 32.7883 30.5478 32.717 30.6553L32.9337 30.799ZM33.0866 30.2554C33.0866 30.0104 33.0031 29.8063 32.825 29.6632L32.6621 29.8659C32.7681 29.951 32.8266 30.0742 32.8266 30.2554H33.0866ZM32.825 29.6632C32.6513 29.5236 32.4137 29.4633 32.131 29.4633V29.7233C32.3809 29.7233 32.5517 29.7771 32.6621 29.8659L32.825 29.6632ZM32.131 29.4633C31.8776 29.4633 31.6403 29.4993 31.4202 29.5727L31.5024 29.8194C31.6932 29.7558 31.9024 29.7233 32.131 29.7233V29.4633ZM31.4202 29.5727C31.2091 29.6431 31.0032 29.7278 30.8026 29.8268L30.9177 30.0599C31.1077 29.9662 31.3026 29.886 31.5024 29.8194L31.4202 29.5727ZM30.9775 29.8874L30.6578 29.2177L30.4232 29.3297L30.7428 29.9994L30.9775 29.8874ZM30.6038 29.3873C31.0994 29.1114 31.6293 28.9737 32.1956 28.9737V28.7138C31.585 28.7138 31.0115 28.8627 30.4773 29.1601L30.6038 29.3873ZM32.1956 28.9737C32.6719 28.9737 33.0337 29.0902 33.2957 29.3088L33.4623 29.1092C33.1408 28.8409 32.7138 28.7138 32.1956 28.7138V28.9737ZM33.2957 29.3088C33.5538 29.5243 33.6865 29.8216 33.6865 30.2173H33.9465C33.9465 29.7556 33.7876 29.3808 33.4623 29.1092L33.2957 29.3088ZM33.6865 30.2173C33.6865 30.395 33.6605 30.5483 33.6111 30.6795L33.8545 30.771C33.9168 30.6054 33.9465 30.4201 33.9465 30.2173H33.6865ZM33.6111 30.6795C33.561 30.8127 33.4847 30.9415 33.3802 31.0659L33.5794 31.2331C33.7007 31.0886 33.793 30.9346 33.8545 30.771L33.6111 30.6795ZM33.3802 31.0659C33.2765 31.1895 33.0907 31.3577 32.8158 31.5721L32.9757 31.7771C33.2537 31.5603 33.4573 31.3784 33.5794 31.2331L33.3802 31.0659ZM32.8155 31.5723C32.5777 31.759 32.4055 31.9232 32.3134 32.0636L32.5307 32.2063C32.5984 32.1032 32.742 31.9605 32.976 31.7768L32.8155 31.5723ZM32.3134 32.0636C32.2149 32.2136 32.1722 32.405 32.1722 32.6258H32.4322C32.4322 32.4357 32.4693 32.2998 32.5307 32.2063L32.3134 32.0636ZM32.1722 32.6258V32.797H32.4322V32.6258H32.1722ZM32.3022 32.667H31.5564V32.927H32.3022V32.667ZM31.5304 34.353C31.5304 34.1807 31.5724 34.0755 31.6334 34.0128C31.6938 33.9508 31.7942 33.9085 31.9597 33.9085V33.6485C31.7523 33.6485 31.5731 33.702 31.4471 33.8314C31.3216 33.9603 31.2704 34.1423 31.2704 34.353H31.5304ZM31.9597 33.9085C32.1186 33.9085 32.2197 33.9515 32.2846 34.0189L32.4719 33.8387C32.344 33.7057 32.1661 33.6485 31.9597 33.6485V33.9085ZM32.2846 34.0189C32.3511 34.088 32.3928 34.1931 32.3928 34.353H32.6528C32.6528 34.1477 32.5982 33.9699 32.4719 33.8387L32.2846 34.0189ZM32.3928 34.353C32.3928 34.509 32.3511 34.6171 32.281 34.6927L32.4716 34.8695C32.5969 34.7345 32.6528 34.5572 32.6528 34.353H32.3928ZM32.281 34.6927C32.2139 34.765 32.1135 34.809 31.9597 34.809V35.069C32.1662 35.069 32.3434 35.0077 32.4716 34.8695L32.281 34.6927ZM31.9597 34.809C31.8049 34.809 31.7052 34.7656 31.6398 34.6959L31.4502 34.8738C31.5775 35.0096 31.7543 35.069 31.9597 35.069V34.809ZM31.6398 34.6959C31.5724 34.6241 31.5304 34.5158 31.5304 34.353H31.2704C31.2704 34.5606 31.3248 34.7402 31.4502 34.8738L31.6398 34.6959Z"
        fill="#53B7B0"
      />
    </svg>
  );
}

NoSearchResults.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

NoSearchResults.defaultProps = {
  height: 53,
  width: 53
};

export default NoSearchResults;
